import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-br from-sky-400 to-sky-600 rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg">
              FD
            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">FUNDACIÓN</h1>
              <p className="text-sm font-semibold text-sky-600">FUTUROS DEL DEPORTE</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-7">
            <button
              onClick={() => scrollToSection('mision')}
              className="text-gray-700 hover:text-sky-600 font-medium transition-colors"
            >
              Misión
            </button>
            <button
              onClick={() => scrollToSection('programas')}
              className="text-gray-700 hover:text-sky-600 font-medium transition-colors"
            >
              Programas
            </button>
            <button
              onClick={() => scrollToSection('galeria')}
              className="text-gray-700 hover:text-sky-600 font-medium transition-colors"
            >
              Galería
            </button>
            <button
              onClick={() => scrollToSection('colaborar')}
              className="text-gray-700 hover:text-sky-600 font-medium transition-colors"
            >
              Colaborar
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="text-gray-700 hover:text-sky-600 font-medium transition-colors"
            >
              Contacto
            </button>
            <Button
              data-testid="donate-header-btn"
              onClick={() => scrollToSection('donar')}
              className="bg-sky-600 hover:bg-sky-700 text-white px-6 transition-colors"
            >
              Donar
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 bg-white">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('mision')}
                className="text-gray-700 hover:text-sky-600 font-medium transition-colors text-left px-4 py-2"
              >
                Misión
              </button>
              <button
                onClick={() => scrollToSection('programas')}
                className="text-gray-700 hover:text-sky-600 font-medium transition-colors text-left px-4 py-2"
              >
                Programas
              </button>
              <button
                onClick={() => scrollToSection('galeria')}
                className="text-gray-700 hover:text-sky-600 font-medium transition-colors text-left px-4 py-2"
              >
                Galería
              </button>
              <button
                onClick={() => scrollToSection('colaborar')}
                className="text-gray-700 hover:text-sky-600 font-medium transition-colors text-left px-4 py-2"
              >
                Colaborar
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="text-gray-700 hover:text-sky-600 font-medium transition-colors text-left px-4 py-2"
              >
                Contacto
              </button>
              <Button
                onClick={() => scrollToSection('donar')}
                className="bg-sky-600 hover:bg-sky-700 text-white mx-4 transition-colors"
              >
                Donar
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
